<template>
  <b-nav vertical class="side-nav-content">
    <b-nav-item
      class="sidenav-item sidenav-item-heading border-bottom settings-heading"
      style="font-weight:400 !important"
    >Templates</b-nav-item>

    <b-nav-item
      :to="{name:'Templates',query:{stg_menu:'Invoice',template_group : 'invoice'}}"
      class="sidenav-item border-bottom py-1"
      :class="{'active':(active =='invoice' || active == '')}"
    >Invoice</b-nav-item>
    <b-nav-item
      v-if="general_settings_details.preferences.modules.Sales"
      :to="{name:'Templates',query:{stg_menu:'Sales',template_group : 'quotation'}}"
      class="sidenav-item border-bottom py-1"
      :class="{'active':active=='quotation'}"
    >Quotation</b-nav-item>
    <b-nav-item
      :to="{name:'Templates',query:{ stg_menu:'Credit Note',template_group : 'creditnote'}}"
      class="sidenav-item border-bottom py-1"
      :class="{'active':active=='creditnote'}"
    >Credit</b-nav-item>
     <b-nav-item
      :to="{ name: 'Templates', query: { stg_menu:'Payments Received',template_group: 'paymentreceived' } }"
      class="sidenav-item border-bottom py-1"
      :class="{ active: active == 'paymentreceived' }"
    >Payment Receipt</b-nav-item>
     <b-nav-item
      :to="{ name: 'Templates', query: { stg_menu:'Customer Advance',template_group: 'customeradvance' } }"
      class="sidenav-item border-bottom py-1"
      :class="{ active: active == 'customeradvance' }"
    >Customer Advance</b-nav-item>
      <b-nav-item
      :to="{ name: 'Templates', query: { stg_menu:'Customer Deposit',template_group: 'customerdeposit' } }"
      class="sidenav-item border-bottom py-1"
      :class="{ active: active == 'customerdeposit' }"
    >Customer Deposit</b-nav-item>
    <b-nav-item
      :to="{name:'Templates',query:{stg_menu:'Customer Statement',template_group : 'customer_statement'}}"
      class="sidenav-item border-bottom py-1"
      :class="{'active':active=='customer_statement'}"
    >Customer</b-nav-item>
  </b-nav>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "SettingsLayout",
  props: ["active"],
  computed: {
    ...mapGetters(["general_settings_details"])
  }
};
</script>